//select particular topic
export const copyingVal = (vueObj) => {
	console.log(vueObj.topicDetails);
	vueObj.selTopic = vueObj.topicDetails.topicID;
	vueObj.clone = { ...vueObj.topicDetails };
	vueObj.nameEdit = vueObj.clone.name;
	vueObj.topicModal = true;
};

//go to test page
export const goToTest = (vueObj) => {
	if (vueObj.roles.includes("GET_TEST") && vueObj.topicDetails.active) {
		vueObj.$router.push({
			// path: `/test/${vueObj.topicDetails.topicID}/${vueObj.topicDetails.name}`
			name: "Tests",
			// path: `/test`,
			params: {
				topicID: vueObj.topicDetails.topicID,
				topicName: vueObj.topicDetails.name,
			},
			query: {
				sort: vueObj.sort,
				type: vueObj.type,
			},
		});

		vueObj.$store.commit("topicVUEX/saveSelectedTopic", {
			topicID: vueObj.topicDetails.topicID,
			topicName: vueObj.topicDetails.name,
		});
	} else {
		vueObj.errorToast("You don't have access to this page!");
	}
};

export const tabRedirect = (vueObj) => {
	if (vueObj.$route.query.sort || vueObj.$route.query.type) {
		vueObj.sort_selected = vueObj.$route.query.sort;
		vueObj.topicCardselected = vueObj.$route.query.type;
		changeSort(vueObj);
		return;
	}
	vueObj.clearFilterModels();
};

export const changeSort = (vueObj) => {
	if (vueObj.sort_selected == "1") {
		vueObj.sortColumn = "name";
		vueObj.sortorder = 1;
	} else if (vueObj.sort_selected == "2") {
		vueObj.sortColumn = "name";
		vueObj.sortorder = -1;
	} else if (vueObj.sort_selected == "3") {
		vueObj.sortColumn = "createdAt";
		vueObj.sortorder = 1;
	} else if (vueObj.sort_selected == "4") {
		vueObj.sortColumn = "createdAt";
		vueObj.sortorder = -1;
	} else if (vueObj.sort_selected == "5") {
		vueObj.sortColumn = "updatedAt";
		vueObj.sortorder = 1;
	} else {
		vueObj.sortColumn = "updatedAt";
		vueObj.sortorder = -1;
	}

	if (vueObj.topicCardselected == "Active") {
		vueObj.activeForTopic = 1;
	} else if (vueObj.topicCardselected == "Inactive") {
		vueObj.activeForTopic = 0;
	} else {
		vueObj.activeForTopic = 2;
	}

	resetPagination(vueObj);
	vueObj.showsortcard = false;
	vueObj.showtopiccard = false;
};

export const resetPagination = (vueObj) => {
	vueObj.page = 0;
	vueObj.showLoader = false;
	vueObj.LoaderStatus = true;
	vueObj.getTopics();
};

export const onScroll = (e, vueObj) => {
	// Get the target element of the scroll event.
	const { target } = e;
	// Check if the user has reached the bottom of the scrollable area.
	if (
		Math.ceil(target.scrollTop) >=
		target.scrollHeight - target.offsetHeight
	) {
		// Check if there is more data to load.
		if (checkbetween(vueObj.pageEnd, 0, vueObj.total)) {
			vueObj.page++;
			vueObj.getTopics();
		}
	}
};

export const checkbetween = (x, min, max) => {
	// Return `true` if `x` is between `min` and `max`, otherwise `false`.
	return x > min && x < max;
};

export const topicEdit = (data, cloneData, vueObj) => {
	vueObj.topicState[data].name = cloneData.name;
	vueObj.topicState[data].description = cloneData.description;
	vueObj.topicState[data].publicAvailability = cloneData.publicAvailability;
};

export const simple = (vueObj) => {
	vueObj.showtopiccard = false;
	vueObj.showfiltercard = false;
	vueObj.showsortcard = false;
};

export const topicFunction = (vueObj) => {
	vueObj.showtopiccard = !vueObj.showtopiccard;
	vueObj.$forceUpdate();
};

export const hideTopicFunction = (vueObj) => {
	vueObj.showtopiccard = false;
};

export const sortFunction = (vueObj) => {
	vueObj.showsortcard = !vueObj.showsortcard;
	vueObj.$forceUpdate();
};

export const hideSortFunction = (vueObj) => {
	vueObj.showsortcard = false;
};

export const filterFunction = (vueObj) => {
	vueObj.filterdata = { ...vueObj.storefilterdata };
	vueObj.showfiltercard = !vueObj.showfiltercard;
	vueObj.$forceUpdate();
};

export const cardoptions = (data, value, vueObj) => {
	vueObj.topicState.map((obj) => {
		if (value) {
			obj.editoption = false;
		}
		if (obj.topicID == data) {
			obj.editoption = value;
		}
	});
};
